// Small display helpers used across the table components.

export const humanize = (v) =>
  v == null || v === ''
    ? '—'
    : String(v).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const orDash = (v) => (v == null || v === '' ? '—' : v);

export const formatDateTime = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}. ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const formatNumber = (n) =>
  n == null ? '—' : Number(n).toLocaleString(undefined, { maximumFractionDigits: 4 });
